import { QueryKey } from '@tanstack/react-query';
import apiClient from '../../../services/apiClient';
import {
  EntryFilter,
  EntryRequest,
  EntryRequestResponse,
} from '../types/entry-response';
import { TransformFilters } from '../../../utils';

export const EntryReqAPI = {
  gets: async ({
    queryKey,
  }: {
    queryKey: QueryKey;
  }): Promise<EntryRequestResponse> => {
    const [, filters] = queryKey as [string, EntryFilter?];
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get('/api/petition/entry', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return response.data;
  },
  get: async (id: string): Promise<EntryRequest> => {
    const response = await apiClient.get(`/api/petition/entry/${id}`);

    return response.data;
  },
  put: async (
    id: string,
    data: Record<string, EntryRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/entry/${id}`, data);
    return response.data;
  },
  post: async (req: EntryRequest): Promise<void> => {
    const response = await apiClient.post(
      '/api/petition/entry',
      {
        ...req,
        documents: req?.documents?.map((doc) => doc?.file) || [],
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    const response = await apiClient.delete(`/api/petition/entry/${id}`);
    return response.data;
  },
  downloadPDF: async (id: string): Promise<void> => {
    try {
      const { data } = await apiClient.get(`/api/petition/entry/pdf/${id}`);
      const { url: fileUrl, filename = 'Comprobante_de_solicitud.pdf' } = data || {};

      if (!fileUrl) throw new Error('No se encontró la URL del documento.');

      const blob = await (await fetch(fileUrl)).blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: filename,
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      throw error;
    }
  },
  downloadFiles: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/entry/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `entradas_exportadas.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      console.error('Error en downloadFiles:', error);
      throw error;
    }
  },
};
